var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.className,style:(_vm.disabled
      ? 'color: #a2a2a2;border: 1px solid #b7b7b6;background: #d4cdc5;'
      : ''),attrs:{"disabled":_vm.disabled},on:{"click":function($event){$event.stopPropagation();return _vm.handleButtonClick.apply(null, arguments)}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }